/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAltArtCostResponse } from '../../models/get-alt-art-cost-response';

export interface AltArtServiceGetAltArtCost$Params {
  gachaId: string;
  altArtId: number;
}

export function altArtServiceGetAltArtCost(http: HttpClient, rootUrl: string, params: AltArtServiceGetAltArtCost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAltArtCostResponse>> {
  const rb = new RequestBuilder(rootUrl, altArtServiceGetAltArtCost.PATH, 'get');
  if (params) {
    rb.path('gachaId', params.gachaId, {});
    rb.path('altArtId', params.altArtId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAltArtCostResponse>;
    })
  );
}

altArtServiceGetAltArtCost.PATH = '/api/v3/gateway/gacha/{gachaId}/altart/{altArtId}/cost';
